// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.business-page.compact-page {
  max-width: 960px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  column-gap: 8px;
  padding-top: 12px;
}
.business-page.compact-page > * {
  grid-column: 1/-1;
  min-width: 0;
}
.business-page.compact-page .business-back {
  grid-row: 1;
  font-size: 12px;
  line-height: 18px;
  margin-bottom: 6px;
}
.business-page.compact-page > h1 {
  grid-column: 1;
  grid-row: 2;
  align-self: center;
  margin: 0 0 10px;
  font-size: clamp(23px, 4vw, 28px);
  letter-spacing: -0.03em;
}
.business-page.compact-page .business-subtitle {
  display: none;
}
.business-page.compact-page .compact-header-actions {
  grid-column: 2;
  grid-row: 2;
  display: flex;
  gap: 6px;
  margin-bottom: 10px;
}
.business-page.compact-page .compact-primary, .business-page.compact-page .compact-secondary, .business-page.compact-page .compact-icon-button, .business-page.compact-page .compact-link-button {
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: none;
  border-radius: 10px;
  padding: 8px 12px;
  font-size: 13px;
  line-height: 1.35;
  text-decoration: none;
  text-align: center;
}
.business-page.compact-page .compact-primary {
  background: #e72f44;
  color: white;
}
.business-page.compact-page .compact-secondary {
  background: #edf1f6;
  color: #3e4860;
}
.business-page.compact-page .compact-icon-button {
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  padding: 0;
  background: white;
  color: #6c7891;
  border: 1px solid #e1e6ef;
}
.business-page.compact-page .compact-link-button {
  background: none;
  padding-inline: 4px;
  color: #6c7891;
  font-size: 12px;
}
.business-page.compact-page .compact-card {
  padding: 14px;
  margin-bottom: 10px;
  min-width: 0;
  border: 1px solid #e1e6ef;
  border-radius: 16px;
  background: white;
}
.business-page.compact-page .compact-card h2 {
  font-size: 16px;
  line-height: 1.35;
  margin: 0 0 10px;
}
.business-page.compact-page .compact-card h3 {
  font-size: 14px;
  margin: 0 0 8px;
}
.business-page.compact-page .compact-card p {
  font-size: 12px;
  line-height: 1.5;
  margin: 8px 0;
}
.business-page.compact-page .compact-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
}
.business-page.compact-page .compact-heading h2, .business-page.compact-page .compact-heading h3 {
  margin: 0;
}
.business-page.compact-page .compact-heading > span {
  font-size: 12px;
  color: #78849a;
}
.business-page.compact-page .compact-muted {
  color: #78849a;
  font-size: 12px;
  line-height: 1.5;
}
.business-page.compact-page .compact-alert {
  font-size: 12px;
  line-height: 1.5;
  padding: 10px 12px;
  margin: 0 0 10px;
  border-radius: 11px;
}
.business-page.compact-page .compact-alert.warning {
  color: #8c673a;
  background: #fff6e8;
}
.business-page.compact-page .compact-alert.error {
  color: #a71b34;
  background: #fff0f2;
}
.business-page.compact-page .compact-alert.success {
  color: #32775b;
  background: #edf7f1;
}
.business-page.compact-page .compact-search {
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  min-width: 0;
}
.business-page.compact-page .compact-search > svg {
  position: absolute;
  left: 12px;
  width: 18px;
  color: #78849a;
  pointer-events: none;
}
.business-page.compact-page .compact-search input {
  width: 100%;
  min-width: 0;
  min-height: 44px;
  padding: 10px 44px 10px 38px;
  font-size: 16px;
  box-sizing: border-box;
}
.business-page.compact-page .compact-search input::-webkit-search-cancel-button {
  appearance: none;
}
.business-page.compact-page .compact-search button {
  position: absolute;
  right: 1px;
  border: none;
  background: none;
}
.business-page.compact-page .compact-form fieldset {
  margin: 0;
  padding: 0;
  min-width: 0;
  border: none;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}
.business-page.compact-page .compact-form label {
  min-width: 0;
  font-size: 12px;
  line-height: 1.35;
  gap: 5px;
}
.business-page.compact-page .compact-form input:not([type=checkbox]), .business-page.compact-page .compact-form select, .business-page.compact-page .compact-form textarea {
  min-width: 0;
  width: 100%;
  min-height: 44px;
  font-size: 16px;
  padding: 8px 9px;
  box-sizing: border-box;
}
.business-page.compact-page .compact-form input:focus, .business-page.compact-page .compact-form select:focus, .business-page.compact-page .compact-form textarea:focus {
  outline: 2px solid rgba(231, 47, 68, 0.1882352941);
  border-color: #e72f44;
}
.business-page.compact-page .compact-form .compact-wide {
  grid-column: 1/-1;
}
.business-page.compact-page .compact-form .section-label {
  font-size: 12px;
}
.business-page.compact-page .compact-form .section-btn-secondary, .business-page.compact-page .compact-form .section-upload-remove {
  min-height: 44px;
  font-size: 13px;
}
.business-page.compact-page .compact-form .section-field {
  margin-top: 10px;
}
.business-page.compact-page .compact-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 12px;
}
.business-page.compact-page .compact-actions > .compact-primary {
  flex: 1 1;
}
.business-page.compact-page .compact-checkbox {
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 44px;
  gap: 10px;
  font-size: 12px;
  cursor: pointer;
}
.business-page.compact-page .compact-checkbox input {
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  accent-color: #e72f44;
}
.business-page.compact-page .compact-details > summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 44px;
  font-size: 13px;
  cursor: pointer;
  list-style: none;
}
.business-page.compact-page .compact-details > summary::-webkit-details-marker {
  display: none;
}
.business-page.compact-page .compact-details > summary > svg {
  width: 16px;
  height: 16px;
  color: #78849a;
  flex-shrink: 0;
}
.business-page.compact-page .compact-details[open] > summary > svg {
  transform: rotate(180deg);
}
.business-page.compact-page .compact-card.compact-details {
  padding-block: 0;
}
.business-page.compact-page .compact-tabs {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 3px;
  padding: 3px;
  margin-bottom: 12px;
  background: #e9edf4;
  border-radius: 12px;
}
.business-page.compact-page .compact-tabs button {
  min-height: 44px;
  border: none;
  border-radius: 9px;
  background: none;
  color: #6f7b92;
  padding: 6px 3px;
  font-size: 12px;
}
.business-page.compact-page .compact-tabs button[aria-pressed=true] {
  color: #232137;
  background: white;
  box-shadow: 0 1px 4px rgba(35, 33, 55, 0.0431372549);
  font-weight: 650;
}
.business-page.compact-page .compact-badge {
  display: inline-flex;
  padding: 3px 6px;
  border-radius: 6px;
  font-size: 10px;
  line-height: 1.3;
  background: #f1f3f8;
  color: #78849a;
}
.business-page.compact-page .compact-badge.warning {
  background: #fff2df;
  color: #97692f;
}
.business-page.compact-page .compact-badge.success {
  background: #edf7f1;
  color: #32775b;
}
.business-page.compact-page .compact-empty {
  padding: 12px 0;
  color: #78849a;
  font-size: 13px;
  line-height: 1.5;
}
.business-page.compact-page .business-error {
  font-size: 13px;
  padding: 12px;
  margin: 0 0 10px;
}
.business-page.compact-page .business-error button {
  min-height: 44px;
  font-size: 13px;
  border: none;
  border-radius: 10px;
  padding: 8px 12px;
  margin-left: 8px;
  background: white;
  color: #a71b34;
}
@media (max-width: 650px) {
  .business-page.compact-page {
    padding: 10px 10px 24px;
  }
  .business-page.compact-page .compact-card {
    padding-inline: 12px;
  }
  .business-page.compact-page .compact-form fieldset {
    gap: 8px;
  }
}

.lkfr-app .business-page.compact-page {
  max-width: 960px;
  margin-inline: auto;
}`, "",{"version":3,"sources":["webpack://./src/pages/shared/compactPage.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EAAkB,aAAA;EAAe,0CAAA;EAA4C,eAAA;EAAiB,iBAAA;AAKhG;AAJE;EAAM,iBAAA;EAAqB,YAAA;AAQ7B;AAPE;EAAiB,WAAA;EAAa,eAAA;EAAiB,iBAAA;EAAmB,kBAAA;AAapE;AAZE;EAAO,cAAA;EAAgB,WAAA;EAAa,kBAAA;EAAoB,gBAAA;EAAkB,iCAAA;EAAmC,uBAAA;AAoB/G;AAnBE;EAAqB,aAAA;AAsBvB;AArBE;EAA0B,cAAA;EAAgB,WAAA;EAAa,aAAA;EAAe,QAAA;EAAU,mBAAA;AA4BlF;AA3BE;EACE,gBAAA;EAAkB,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,QAAA;EAAU,YAAA;EAAc,mBAAA;EAC9G,iBAAA;EAAmB,eAAA;EAAiB,iBAAA;EAAmB,qBAAA;EAAuB,kBAAA;AAuClF;AArCE;EAAmB,mBAAA;EAAqB,YAAA;AAyC1C;AAxCE;EAAqB,mBAAA;EAAqB,cAAA;AA4C5C;AA3CE;EAAuB,WAAA;EAAa,YAAA;EAAc,cAAA;EAAgB,UAAA;EAAY,iBAAA;EAAmB,cAAA;EAAgB,yBAAA;AAoDnH;AAnDE;EAAuB,gBAAA;EAAkB,mBAAA;EAAqB,cAAA;EAAgB,eAAA;AAyDhF;AAxDE;EAAgB,aAAA;EAAe,mBAAA;EAAqB,YAAA;EAAc,yBAAA;EAA2B,mBAAA;EAAqB,iBAAA;AAgEpH;AA/DI;EAAK,eAAA;EAAiB,iBAAA;EAAmB,gBAAA;AAoE7C;AApEiE;EAAK,eAAA;EAAiB,eAAA;AAwEvF;AAxE0G;EAAI,eAAA;EAAiB,gBAAA;EAAkB,aAAA;AA6EjJ;AA3EE;EAAmB,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,QAAA;EAAU,mBAAA;AAkFnG;AAjFI;EAAS,SAAA;AAoFb;AApF0B;EAAS,eAAA;EAAiB,cAAA;AAwFpD;AAtFE;EAAiB,cAAA;EAAgB,eAAA;EAAiB,gBAAA;AA2FpD;AA1FE;EAAiB,eAAA;EAAiB,gBAAA;EAAkB,kBAAA;EAAoB,gBAAA;EAAkB,mBAAA;AAiG5F;AAhGI;EAAY,cAAA;EAAgB,mBAAA;AAoGhC;AApGuD;EAAU,cAAA;EAAgB,mBAAA;AAwGjF;AAxGwG;EAAY,cAAA;EAAgB,mBAAA;AA4GpI;AA1GE;EAAkB,kBAAA;EAAoB,aAAA;EAAe,mBAAA;EAAqB,mBAAA;EAAqB,YAAA;AAiHjG;AAhHI;EAAQ,kBAAA;EAAoB,UAAA;EAAY,WAAA;EAAa,cAAA;EAAgB,oBAAA;AAuHzE;AAtHI;EAAQ,WAAA;EAAa,YAAA;EAAc,gBAAA;EAAkB,4BAAA;EAA8B,eAAA;EAAiB,sBAAA;AA8HxG;AA9HgI;EAAkC,gBAAA;AAiIlK;AAhII;EAAS,kBAAA;EAAoB,UAAA;EAAY,YAAA;EAAc,gBAAA;AAsI3D;AAnII;EAAW,SAAA;EAAW,UAAA;EAAY,YAAA;EAAc,YAAA;EAAc,aAAA;EAAe,gDAAA;EAAkD,SAAA;AA4InI;AA3II;EAAQ,YAAA;EAAc,eAAA;EAAiB,iBAAA;EAAmB,QAAA;AAiJ9D;AAhJI;EAA+C,YAAA;EAAc,WAAA;EAAa,gBAAA;EAAkB,eAAA;EAAiB,gBAAA;EAAkB,sBAAA;AAwJnI;AAvJI;EAA4C,kDAAA;EAA8B,qBAAA;AA2J9E;AA1JI;EAAgB,iBAAA;AA6JpB;AA5JI;EAAiB,eAAA;AA+JrB;AA/JwC;EAAiD,gBAAA;EAAkB,eAAA;AAmK3G;AAlKI;EAAiB,gBAAA;AAqKrB;AAnKE;EAAmB,aAAA;EAAe,QAAA;EAAU,eAAA;EAAiB,gBAAA;AAyK/D;AAzKiF;EAAqB,SAAA;AA4KtG;AA3KE;EAAoB,aAAA;EAAe,mBAAA;EAAqB,mBAAA;EAAqB,gBAAA;EAAkB,SAAA;EAAW,eAAA;EAAiB,eAAA;AAoL7H;AAnLI;EAAQ,WAAA;EAAa,YAAA;EAAc,cAAA;EAAgB,qBAAA;AAyLvD;AAvLE;EAA6B,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,QAAA;EAAU,gBAAA;EAAkB,eAAA;EAAiB,eAAA;EAAiB,gBAAA;AAiMjK;AAhMI;EAA4B,aAAA;AAmMhC;AAnMiD;EAAQ,WAAA;EAAa,YAAA;EAAc,cAAA;EAAgB,cAAA;AAyMpG;AAvME;EAAyC,yBAAA;AA0M3C;AAzME;EAAgC,gBAAA;AA4MlC;AA3ME;EAAgB,aAAA;EAAe,gDAAA;EAAkD,QAAA;EAAU,YAAA;EAAc,mBAAA;EAAqB,mBAAA;EAAqB,mBAAA;AAoNrJ;AAnNI;EAAS,gBAAA;EAAkB,YAAA;EAAc,kBAAA;EAAoB,gBAAA;EAAkB,cAAA;EAAgB,gBAAA;EAAkB,eAAA;AA4NrH;AA3NI;EAA4B,cAAA;EAAgB,iBAAA;EAAmB,oDAAA;EAAiC,gBAAA;AAiOpG;AA/NE;EAAiB,oBAAA;EAAsB,gBAAA;EAAkB,kBAAA;EAAoB,eAAA;EAAiB,gBAAA;EAAkB,mBAAA;EAAqB,cAAA;AAwOvI;AAvOI;EAAY,mBAAA;EAAqB,cAAA;AA2OrC;AA3OuD;EAAY,mBAAA;EAAqB,cAAA;AA+OxF;AA7OE;EAAiB,eAAA;EAAiB,cAAA;EAAgB,eAAA;EAAiB,gBAAA;AAmPrE;AAlPE;EAAkB,eAAA;EAAiB,aAAA;EAAe,gBAAA;AAuPpD;AAvPsE;EAAS,gBAAA;EAAkB,eAAA;EAAiB,YAAA;EAAc,mBAAA;EAAqB,iBAAA;EAAmB,gBAAA;EAAkB,iBAAA;EAAmB,cAAA;AAiQ7M;AAhQE;EAA4B;IAAI,uBAAA;EAoQhC;EApQ2D;IAAgB,oBAAA;EAuQ3E;EAvQmG;IAAyB,QAAA;EA0Q5H;AACF;;AAzQA;EAAwC,gBAAA;EAAkB,mBAAA;AA8Q1D","sourcesContent":[".business-page.compact-page {\n  max-width: 960px; display: grid; grid-template-columns: minmax(0, 1fr) auto; column-gap: 8px; padding-top: 12px;\n  > * { grid-column: 1 / -1; min-width: 0; }\n  .business-back { grid-row: 1; font-size: 12px; line-height: 18px; margin-bottom: 6px; }\n  > h1 { grid-column: 1; grid-row: 2; align-self: center; margin: 0 0 10px; font-size: clamp(23px, 4vw, 28px); letter-spacing: -.03em; }\n  .business-subtitle { display: none; }\n  .compact-header-actions { grid-column: 2; grid-row: 2; display: flex; gap: 6px; margin-bottom: 10px; }\n  .compact-primary, .compact-secondary, .compact-icon-button, .compact-link-button {\n    min-height: 44px; display: inline-flex; align-items: center; justify-content: center; gap: 6px; border: none; border-radius: 10px;\n    padding: 8px 12px; font-size: 13px; line-height: 1.35; text-decoration: none; text-align: center;\n  }\n  .compact-primary { background: #e72f44; color: white; }\n  .compact-secondary { background: #edf1f6; color: #3e4860; }\n  .compact-icon-button { width: 44px; height: 44px; flex: 0 0 44px; padding: 0; background: white; color: #6c7891; border: 1px solid #e1e6ef; }\n  .compact-link-button { background: none; padding-inline: 4px; color: #6c7891; font-size: 12px; }\n  .compact-card { padding: 14px; margin-bottom: 10px; min-width: 0; border: 1px solid #e1e6ef; border-radius: 16px; background: white;\n    h2 { font-size: 16px; line-height: 1.35; margin: 0 0 10px; } h3 { font-size: 14px; margin: 0 0 8px; } p { font-size: 12px; line-height: 1.5; margin: 8px 0; }\n  }\n  .compact-heading { display: flex; align-items: center; justify-content: space-between; gap: 8px; margin-bottom: 10px;\n    h2, h3 { margin: 0; } > span { font-size: 12px; color: #78849a; }\n  }\n  .compact-muted { color: #78849a; font-size: 12px; line-height: 1.5; }\n  .compact-alert { font-size: 12px; line-height: 1.5; padding: 10px 12px; margin: 0 0 10px; border-radius: 11px;\n    &.warning { color: #8c673a; background: #fff6e8; } &.error { color: #a71b34; background: #fff0f2; } &.success { color: #32775b; background: #edf7f1; }\n  }\n  .compact-search { position: relative; display: flex; align-items: center; margin-bottom: 10px; min-width: 0;\n    > svg { position: absolute; left: 12px; width: 18px; color: #78849a; pointer-events: none; }\n    input { width: 100%; min-width: 0; min-height: 44px; padding: 10px 44px 10px 38px; font-size: 16px; box-sizing: border-box; &::-webkit-search-cancel-button { appearance: none; } }\n    button { position: absolute; right: 1px; border: none; background: none; }\n  }\n  .compact-form {\n    fieldset { margin: 0; padding: 0; min-width: 0; border: none; display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }\n    label { min-width: 0; font-size: 12px; line-height: 1.35; gap: 5px; }\n    input:not([type=checkbox]), select, textarea { min-width: 0; width: 100%; min-height: 44px; font-size: 16px; padding: 8px 9px; box-sizing: border-box; }\n    input:focus, select:focus, textarea:focus { outline: 2px solid #e72f4430; border-color: #e72f44; }\n    .compact-wide { grid-column: 1 / -1; }\n    .section-label { font-size: 12px; } .section-btn-secondary, .section-upload-remove { min-height: 44px; font-size: 13px; }\n    .section-field { margin-top: 10px; }\n  }\n  .compact-actions { display: flex; gap: 8px; flex-wrap: wrap; margin-top: 12px; > .compact-primary { flex: 1; } }\n  .compact-checkbox { display: flex; flex-direction: row; align-items: center; min-height: 44px; gap: 10px; font-size: 12px; cursor: pointer;\n    input { width: 20px; height: 20px; flex: 0 0 20px; accent-color: #e72f44; }\n  }\n  .compact-details > summary { display: flex; align-items: center; justify-content: space-between; gap: 8px; min-height: 44px; font-size: 13px; cursor: pointer; list-style: none;\n    &::-webkit-details-marker { display: none; } > svg { width: 16px; height: 16px; color: #78849a; flex-shrink: 0; }\n  }\n  .compact-details[open] > summary > svg { transform: rotate(180deg); }\n  .compact-card.compact-details { padding-block: 0; }\n  .compact-tabs { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 3px; padding: 3px; margin-bottom: 12px; background: #e9edf4; border-radius: 12px;\n    button { min-height: 44px; border: none; border-radius: 9px; background: none; color: #6f7b92; padding: 6px 3px; font-size: 12px; }\n    button[aria-pressed=true] { color: #232137; background: white; box-shadow: 0 1px 4px #2321370b; font-weight: 650; }\n  }\n  .compact-badge { display: inline-flex; padding: 3px 6px; border-radius: 6px; font-size: 10px; line-height: 1.3; background: #f1f3f8; color: #78849a;\n    &.warning { background: #fff2df; color: #97692f; } &.success { background: #edf7f1; color: #32775b; }\n  }\n  .compact-empty { padding: 12px 0; color: #78849a; font-size: 13px; line-height: 1.5; }\n  .business-error { font-size: 13px; padding: 12px; margin: 0 0 10px; button { min-height: 44px; font-size: 13px; border: none; border-radius: 10px; padding: 8px 12px; margin-left: 8px; background: white; color: #a71b34; } }\n  @media (max-width: 650px) { & { padding: 10px 10px 24px; } .compact-card { padding-inline: 12px; } .compact-form fieldset { gap: 8px; } }\n}\n.lkfr-app .business-page.compact-page { max-width: 960px; margin-inline: auto; }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
